import { ApiService } from './ApiService';
import { Result, ResultOf } from '@/types/result';
import { SubscriptionInfo } from '@/pages/Subscription/types/SubscriptionInfo';
import { CancelSubscriptionModel } from '@/pages/Subscription/types/CancelSubscriptionModel';
import { PauseAvailability } from '@/pages/Subscription/types/PauseAvailability';

export class SubscriptionApi extends ApiService {
    base = 'Subscription';
    async getInfo(): Promise<ResultOf<SubscriptionInfo>> {
        return await this.get(this.getUrl('GetInfo'));
    }
    async cancel(data: CancelSubscriptionModel): Promise<Result> {
        return await this.post(this.getUrl('Cancel'), data);
    }
    async restore(userId: number | string): Promise<Result> {
        return await this.get(this.getUrl('Restore'), {
            userId,
        });
    }

    async pause(userId: number | string): Promise<Result> {
        return await this.get(this.getUrl('Pause'), {
            userId,
        });
    }

    async resume(userId: number | string): Promise<Result> {
        return await this.get(this.getUrl('Resume'), {
            userId,
        });
    }

    async getPauseAvailability(): Promise<ResultOf<PauseAvailability>> {
        return await this.get(this.getUrl('GetPauseAvailability'));
    }

    async setProTariffForSuperAdmin(): Promise<Result> {
        return await this.post(this.getUrl('SetProTariffForSuperAdmin'), {}, false);
    }

    async cancelProTariffForSuperAdmin(): Promise<Result> {
        return await this.post(this.getUrl('CancelProTariffForSuperAdmin'), {}, false);
    }
}
